/**
 * Os dois painéis que a mesma tela de orçamento serve — K-3.
 *
 * `OrcamentoConfigPage` atende duas configurações distintas pela prop `secao`
 * (`precos` e `kits-taxas`). O registry mapeia **componente sem props**, e isso é
 * de propósito: ensinar o registry a passar props abriria a porta para cada item
 * inventar a própria assinatura, e o mapa deixaria de ser um mapa.
 *
 * Então cada uma ganha um wrapper de uma linha. Mora aqui, e não no registry,
 * porque um arquivo que exporta componentes **e** um mapa quebra o fast refresh
 * (mesma regra que separou `secoes.ts` de `SecaoIndice.tsx`).
 */
import { OrcamentoConfigPage } from '@/pages/admin/orcamento/OrcamentoConfigPage';

export function OrcamentoPrecos() {
  return <OrcamentoConfigPage embedded secao="precos" />;
}

export function OrcamentoKits() {
  return <OrcamentoConfigPage embedded secao="kits-taxas" />;
}
